/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Icy_Lime_Vole_CryInputs */

const fr_icy_lime_vole_cry = /** @type {(inputs: Icy_Lime_Vole_CryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiement`)
};

/**

* @param {Icy_Lime_Vole_CryInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const icy_lime_vole_cry = /** @type {((inputs?: Icy_Lime_Vole_CryInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Icy_Lime_Vole_CryInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_icy_lime_vole_cry(inputs)
});